import PropTypes from 'prop-types';
import React from 'react';
import { link_target, link_rel } from '../../utils/external_links';

export default function ProductLink(props) {
  const { click_tracker, custom_event_label, product_url, delegatedOnClick } = props;

  const [purchaseURL, noSkim] = click_tracker
    ? [click_tracker, 'noskim']
    : [product_url, ''];

  const handleClick = () => {
    if (delegatedOnClick) {
      delegatedOnClick();
    }
  };

  return (
    <a href={purchaseURL}
      target={link_target(purchaseURL)}
      onClick={handleClick}
      rel={link_rel(purchaseURL, `${noSkim} nofollow sponsored`)}
      data-event-label={custom_event_label}
    >
      {props.children}
    </a>
  );
}

ProductLink.propTypes = {
  click_tracker: PropTypes.string,
  product_url: PropTypes.string,
  custom_event_label: PropTypes.string,
  delegatedOnClick: PropTypes.func,
  children: PropTypes.node
};
